import React from 'react';
import { Sidebar } from './sidebar';
import { Header } from './header';
import { FeedbackWidget } from '@/components/feedback/FeedbackWidget';
import { useSidebar } from '@/contexts/sidebar-context';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { isCollapsed, toggleSidebar } = useSidebar();

  return (
    <div className="flex h-screen bg-rg-bg dark:bg-schmersal-gray-darkest relative overflow-hidden">
      {/* Mobile Sidebar Overlay */}
      {!isCollapsed && (
        <div 
          className="fixed inset-0 z-40 bg-black/50 backdrop-blur-sm md:hidden transition-opacity"
          onClick={toggleSidebar}
        />
      )}

      {/* Sidebar Container */}
      <div className={`
        fixed md:relative z-50 h-screen transition-transform duration-300 ease-in-out
        ${isCollapsed ? '-translate-x-full md:hidden' : 'translate-x-0'}
      `}>
        <Sidebar />
      </div>
      
      {/* Main Content */}
      <div className="flex-1 flex flex-col h-screen overflow-hidden bg-white dark:bg-schmersal-gray-darkest w-full">
        {/* Header */}
        <Header />
        
        {/* Page Content */}
        <main className="flex-1 overflow-auto p-4 md:p-6 flex flex-col bg-rg-bg dark:bg-schmersal-gray-darkest w-full">
          {children}
        </main>
      </div>

      {/* Botão flutuante de feedback (apontar correções na tela) */}
      <FeedbackWidget />
    </div>
  );
}
